import { useMemo } from 'react'

import { type ExtendedDiagnosisFields } from '@/legacy-src/components/diagnosis/client/types'
import { normalizeDiagnosisData } from '@/legacy-src/components/diagnosis/client/utils'

import { type TherapistType } from '../types/TherapistStateType'
import useDiagnosisPreview from './api/useDiagnosisPreview'
import useTherapists from './useTherapists'

const getFavouredTherapist = (favouredList: number[] = [], therapistList?: TherapistType[]) => {
  const favouredTherapists = favouredList
    ?.map((id) => therapistList?.find((therapist) => therapist.therapistId === id))
    .filter(Boolean) as TherapistType[]

  return favouredTherapists[0]
}

const useTherapistsPreview = (data: ExtendedDiagnosisFields) => {
  const diagnosisData = normalizeDiagnosisData(data)

  const { data: previewData, isLoading } = useDiagnosisPreview(diagnosisData)
  const { therapists } = useTherapists('all')

  const therapist = useMemo(() => getFavouredTherapist(previewData, therapists), [previewData, therapists])

  return { therapist, isLoading }
}

export default useTherapistsPreview
